import angular from 'angular';
angular.module('cloudX').component('taskStatusIcon', {
  bindings: {
    value: '<',
  },
  template: ` <i ng-show="!!$ctrl.value" ng-class="{'fa fa-lg': true, 'fa-circle': !$ctrl.value.isBlocked && !$ctrl.value.inapplicable && !$ctrl.value.rejected, 'fa-minus-circle text-danger': $ctrl.value.isBlocked,
  'greyed-out': $ctrl.value.status === 0 && !$ctrl.value.isBlocked,
  'orange': $ctrl.value.status === 1 && !$ctrl.value.isBlocked && !$ctrl.value.inapplicable && !$ctrl.value.rejected,
  'green': $ctrl.value.status === 2 && !$ctrl.value.isBlocked && !$ctrl.value.inapplicable && !$ctrl.value.rejected,
  'fa-times-circle': $ctrl.value.inapplicable,
  'fa-ban': $ctrl.value.rejected,}"></i>`,
});
